import { graphql, Link } from 'gatsby';
import React from 'react';
import { usePageContext } from '../hooks/contexts/usePageContext';
import * as styles from './page404.module.scss';
import { SEO } from '../components/2.0version/seo/Seo';
import { ToursBlockContent } from '../components/2.0version/1old/toursBlockContent/ToursBlockContent';
import { Button } from '../components/2.0version/1old/button';

const NotFoundPage: React.FC = ({ data: { page404 }, location }: any) => {
  const { lang } = usePageContext();
  return (
    <>
      <SEO />
      <div className={styles.wrapper}>
        <ToursBlockContent blocks={page404._rawContent?.[lang] ?? ''} />
        <Button onClick={(e) => {}} color="dark">
          {page404._rawButton?.link.includes('http') ? (
            <a href={page404._rawButton?.link} target={page404._rawButton?.target || ''}>
              {page404._rawButton?.label?.[lang]}
            </a>
          ) : (
            <Link to={page404._rawButton?.link} target={page404._rawButton?.target || ''}>
              {page404._rawButton?.label?.[lang]}
            </Link>
          )}
        </Button>
      </div>
    </>
  );
};

export default NotFoundPage;

export const query = graphql`
  query notFound {
    page404: sanityPage404 {
      _rawButton
      _rawContent
    }
  }
`;
